import { render, staticRenderFns } from "./Metro_SP_160x600.vue?vue&type=template&id=6065edf3&"
import script from "./Metro_SP_160x600.vue?vue&type=script&lang=js&"
export * from "./Metro_SP_160x600.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports